import { render, staticRenderFns } from "./start.vue?vue&type=template&id=1cb69a90&"
import script from "./start.js?vue&type=script&lang=js&"
export * from "./start.js?vue&type=script&lang=js&"
import style0 from "./start.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports